import styled from "styled-components";

type HistoryMainTab = "HISTORY" | "REPORT";

const HistoryTabs = ({
  activeTab,
  onChange,
}: {
  activeTab: HistoryMainTab;
  onChange: (tab: HistoryMainTab) => void;
}) => (
  <TabsMenu className="history-tabs">
    <button
      className={activeTab === "HISTORY" ? "active" : ""}
      onClick={() => onChange("HISTORY")}
    >
      <span>이력</span>
      <span className="line"></span>
    </button>
    <button
      className={activeTab === "REPORT" ? "active" : ""}
      onClick={() => onChange("REPORT")}
    >
      <span>리포트</span>
      <span className="line"></span>
    </button>
  </TabsMenu>
);

export default HistoryTabs;

const TabsMenu = styled.div`
  height: 38px;
  display: flex;
  align-items: center;
  button {
    position: relative;
    height: 38px;
    border: none;
    outline: none;
    background-color: white;
    font-size: 16px;
    width: 200px;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: center;
    transition: all 0.3s ease;
    .line {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: #30a690;

      transform: scaleX(0);
      transform-origin: center;
      transition: transform 0.3s ease;
    }
    &.active {
      color: #30a690;
      .line {
        transform: scaleX(1);
      }
    }
  }
`;
